module.exports = __webpack_public_path__ + "images/bannerES-c072a2fa8157b1a6527a5ffa4d557c0f.jpg";